import React from "react"

import { PageOptions } from "@src/localization/en/createCampaign"

const CurrentStep = React.createContext<PageOptions | null>(null)

export default CurrentStep
